import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class ToolBtn extends Phaser.GameObjects.Image {

  static selectStateButtons = [];

  static get ERASE_CLICKED() {return 'ERASE_CLICKED';}

  static get FILL_CLICKED() {return 'FILL_CLICKED';}

  static get DRAW_CLICKED() {return 'DRAW_CLICKED';}

  static get MENU_CLICKED() {return 'MENU_CLICKED';}

  static get GRID_CLICKED() {return 'GRID_CLICKED';}

  static get UNDO_CLICKED() {return 'UNDO_CLICKED';}

  constructor (scene, frameUnselected, frameSelected, eventToFire, id, selectState = false) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, frameUnselected);
    this.frameSelected = frameSelected;
    this.frameUnselected = frameUnselected;
    if (selectState) ToolBtn.selectStateButtons.push(this);

    this.toolBtnDisplay = null;
    this.toolBtnId = null;
    this.btnWidth = null;
    this.btnHeight = null;

    this.toolBtnId = id;
    this.toolBtnDisplay = this;
    this.btnWidth = this.toolBtnDisplay.getBounds().width;
    this.btnHeight = this.toolBtnDisplay.getBounds().height;
    this.isSelected = false;

    this.setInteractive();

    switch (eventToFire) {
      case ToolBtn.GRID_CLICKED:
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          this.showSelected(!this.isSelected);
        });
      case ToolBtn.MENU_CLICKED:
      case ToolBtn.UNDO_CLICKED:
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          this.emit(eventToFire, this);
        });
        break;
      case ToolBtn.ERASE_CLICKED:
      case ToolBtn.FILL_CLICKED:
      case ToolBtn.DRAW_CLICKED:
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
          if (this.isSelected) return;
          this.emit(eventToFire, this);

          ToolBtn.selectStateButtons.forEach((btn) => {
            btn.showSelected(false);
          });

          this.showSelected(true);

          ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this.scene);
        });
        break;
    }
  };

  showSelected(selected) {
    this.isSelected = selected;
    const frame = this.isSelected ? this.frameSelected : this.frameUnselected;
    this.toolBtnDisplay.setFrame(frame);
  };

}